<template>
  <div class="enterdiv">
    <div class="htmldiv">
      <div class="st fs28 fbold tcenter pt30 mb40">
        <div class="stborder dinline-block prelative wbg">
          <div class="tt wd100 pabsolute">
            <div class="dinline-block fbold twhite">
              <span class="tc14">快捷</span>入口
            </div>
          </div>
        </div>
      </div>
      <div class="cont">
        <div class="sdiv pr10 dinline-block vtop br5 bgw tc11 cpointer trans3" onclick="window.open('https://cr.zjzs.net/');">
          <div class="igs dinline-block vtop tran3"></div>
          <div class="dinline-block vtop pt30">
            <div class="fs26">成考录取查询</div>
            <div class="tupper mt5">Enquiry for admission</div>
          </div>
        </div>
        <div class="sdiv pr10 dinline-block vtop br5 bgw tc11 cpointer trans3" onclick="javascript:;">
          <div class="igs dinline-block vtop tran3"></div>
          <div class="dinline-block vtop pt30">
            <div class="fs26">学分银行</div>
            <div class="tupper mt5">Credit Bank</div>
          </div>
        </div>
        <div class="sdiv pr10 dinline-block vtop br5 bgw tc11 cpointer trans3" onclick="window.open('/lms/web');">
          <div class="igs dinline-block vtop tran3"></div>
          <div class="dinline-block vtop pt30">
            <div class="fs26">学历教育登录口</div>
            <div class="tupper mt5">Qualification Education Login</div>
          </div>
        </div>
        <div class="sdiv pr10 dinline-block vtop br5 bgw tc11 cpointer trans3" onclick="window.open('/lms/web');">
          <div class="igs dinline-block vtop tran3"></div>
          <div class="dinline-block vtop pt30">
            <div class="fs26">技能培训考证登录口</div>
            <div class="tupper mt5">Skills training certificate login</div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
    export default {
        name: "quick"
    }
</script>

<style scoped>
  .index-wrap .enterdiv{min-height: 282px;background: url(../../assets/images/index_04.jpg) repeat-x;}
  .index-wrap .enterdiv .sdiv:hover{background-color: #063674;color: #fff;}
  .index-wrap .enterdiv .sdiv:hover .igs{background-position: -3px -180px;}
  .index-wrap .enterdiv .sdiv:nth-of-type(2):hover .igs{background-position: -120px -180px;}
  .index-wrap .enterdiv .sdiv:nth-of-type(3):hover .igs{background-position: -240px -180px;}
  .index-wrap .enterdiv .sdiv:nth-of-type(4):hover .igs{background-position: -352px -180px;}
  .index-wrap .enterdiv .sdiv{margin: 0 8px;padding-right: 15px;height: 120px;}
  .index-wrap .enterdiv .igs{width: 90px;height: 100%;background: url(../../assets/images/cn1.png) no-repeat  -3px -282px;}
  .index-wrap .enterdiv .sdiv:first-child{margin-left: 0;}
  .index-wrap .enterdiv .sdiv:last-child{margin-right: 0;}
  .index-wrap .enterdiv .sdiv:nth-of-type(2) .igs{background-position: -120px -283px;}
  .index-wrap .enterdiv .sdiv:nth-of-type(3) .igs{background-position: -240px -280px;}
  .index-wrap .enterdiv .sdiv:nth-of-type(4) .igs{background-position: -352px -280px;}
</style>



// WEBPACK FOOTER //
// src/components/index/quick.vue